'use strict';

export default function chartConfig(scope, $filter) {
  'ngInject';

  const TIMES_VIEW_LIMIT = 15;

  let tooltipFormat = {
    headerFormat: '',
    pointFormatter: function () {
      let tip_format = "";

      tip_format += `<br/><span style="color: ${ this.color };font-size: 12px">\u25CF</span> <span style="font-size: 14px;">${this.series.name}: `;
      tip_format += `${ this.x } kW`;
      tip_format += "</span>";

      return tip_format;
    }
  };

  let chartConfig = {
    chart: {
      type: 'column',
      height: 300,
      zoomType: 'x',
      resetZoomButton: {
        theme: {
          fill: 'white',
          stroke: 'silver',
          states: {
            hover: {
              fill: 'rgba(215, 215,215,0.9)',
              style: {
                // color: 'white'
              }
            }
          }
        }
      },
      events: {
        load: function () {
          // Highcharts オブジェクトへの参照をコンパクトに実現するため、arrow function を用いない
          scope.chart = this;
        }
      }
    },
    colors: ['#2b908f'],
    title: {text: '1ヶ月間のデマンド値分布'},
    xAxis: {
      categories: scope.categories,
      crosshair: true,
      labels: {
        format: '{value}'
      },
      title: {
        text: '需要電力値 [kW]'
      }
    },
    yAxis: {
      labels: {
        format: '{value}'
      },
      title: {
        text: '発生回数'
      }
    },
    legend: {
      enabled: false
    },
    plotLines: [
      {
        id: 'target'
      },
      {
        id: 'limit'
      },
      {
        id: 'contract'
      }
    ],
    tooltip: {
      enabled: true,
      shared: true,
      followPointer: true
    },
    plotOptions: {
      column: {
        grouping: false,
        borderWidth: 2
      }
    },
    series: [
      {
        name: '発生回数',
        color: '#1F85CF',
        marker: {symbol: 'circle'},
        pointWidth: 5,
        tooltip: {
          headerFormat: '',
          pointFormatter: function () {
            let tip_format = `<span style="font-size: 14px;">需要電力値: ${this.x} kW</span>`;
            tip_format += `<br/><span style="font-size: 14px;">${this.series.name}: `;
            tip_format += `${ this.y } 回`;
            tip_format += `</span><br/><span style="font-size: 14px;">発生時刻:<br/>`;

            for(let i=0; i < this.times.length; i++) {
              if(i >= TIMES_VIEW_LIMIT) {
                tip_format += '...';
                i = this.times.length;
              } else {
                let formattedTime = $filter('date')(this.times[i], 'MM/dd HH:mm');
                tip_format += `${formattedTime}<br/>`;
              }
            }

            tip_format += `</span>`;

            return tip_format;

          }
        }
      },
      {
        name: '契約電力',
        marker: {enabled: false},
        color: '#D32F2F',
        tooltip: tooltipFormat
      },
      {
        name: '限界電力',
        marker: {enabled: false},
        color: '#e67e22',
        tooltip: tooltipFormat
      },
      {
        name: '目標電力',
        marker: {enabled: false},
        color: '#8bc34a',
        tooltip: tooltipFormat
      }
    ]
  };

  return chartConfig;
}



// WEBPACK FOOTER //
// ./public/dev/app/demand_report/histogram/demand_histogram.config.js